import {LogLevel} from "../app/core/services/logger/log-level.enum";
import {LOG_LEVEL, LOGGER_PROVIDERS} from "../app/core/injection-tokens";
import {
  LogConsoleService
} from "../app/core/services/logger/logger-providers/log-console-service/log-console.service";

const API_URL = "https://api-h2adhbejathxa7g6.a02.azurefd.net:443/tst/ssba-backend";

export const environment = {
  production: false,
  apiUrl: API_URL + '/v1',
  stage: "test",
  useMockAuth: false,
  providers: [
    {provide: LOG_LEVEL, useValue: LogLevel.DEBUG},
    {provide: LOGGER_PROVIDERS, useClass: LogConsoleService, multi: true},
  ],
  msalConfig: {
    auth: {
      clientId: '73c587b9-f4db-4e81-9b00-d90e1104d39f',
    },
    redirectUri: '/tst/app/',
  },
  apiConfig: {
    scopes: ['openid', 'https://healthciam.onmicrosoft.com/auc-ssba-dev-appreg-webapp/access.backend'],
    uri: API_URL
  },
  b2cPolicies: {
    names: {
      signUpSignIn: "B2C_1A_SSBA_SIGNIN_HAG"
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://healthciam.b2clogin.com/healthciam.onmicrosoft.com/B2C_1A_SSBA_SIGNIN_HAG'
      }
    },
    authorityDomain: "healthciam.b2clogin.com"
  }
};
